'use client';

import { FC, useState } from 'react';
import Button from '@/components/Button/BaseButton';
import styles from './ClearPublicCache.module.css';
import config from 'config-base';
import { ClearPublicCacheProps } from './types';

const ClearPublicCache: FC<ClearPublicCacheProps> = ({ pageName, timestamp }) => {
  const isAdmin = typeof window !== 'undefined' && document.cookie.includes('is-admin-user');
  const [isLoading, setIsLoading] = useState(false);

  const handleClearPageCache = async () => {
    setIsLoading(true);
    try {
      await fetch(`${config.mainPyramydairUrl}/api/marketplace/v1/next/revalidate/page?pageName=${pageName}`, {
        headers: {
          'Content-Type': 'application/json',
          'x-site-code': `${config.brandCode}`,
          cookie: document.cookie,
          credentials: 'include',
        },
      });
      alert(`Cache cleared successfully for ${pageName}`);
    } catch (error) {
      console.error(`Error clearing cache for ${pageName}:`, error);
      alert(`Failed to clear cache for ${pageName}. Please try again.`);
    } finally {
      setIsLoading(false);
    }
  };

  const handleClearPublicPagesCache = async () => {
    setIsLoading(true);
    try {
      await fetch(`${config.mainPyramydairUrl}/api/marketplace/v1/next/revalidate/publicPages`);
      alert('Cache cleared successfully for all react static public pages (brands/about/faq/contact-us/review-policy)');
    } catch (error) {
      console.error('Error clearing cache for all public pages:', error);
      alert('Failed to clear cache for all public pages. Please try again.');
    } finally {
      setIsLoading(false);
    }
  };

  return isAdmin ? (
    <div className={styles.container}>
      <div className={styles.adminInfo}>
        <p>
          Admin Info: {pageName} content fetched/timestamp at: {timestamp}
        </p>
        <p>America/New_York time zone</p>
      </div>
      <div className={styles.buttonContainer}>
        <Button
          onClick={handleClearPageCache}
          data-testid={`clear-public-page-btn-${pageName}`}
          classes={styles.button}
          label={`Clear ${pageName} cache`}
          disabled={isLoading}
        />
        <Button
          onClick={handleClearPublicPagesCache}
          data-testid={'clear-all-public-pages-cache-btn'}
          classes={styles.button}
          label="Clear public pages cache"
          disabled={isLoading}
        />
      </div>
    </div>
  ) : null;
};

export default ClearPublicCache;
